<template>
<span style="width:100%">
    <label-select
    :label="label"
     v-bind="$attrs"
     v-on="$listeners"
  >
    <slot>
      <label-select-option
        v-for="(item,index) in seletData"
        :disabled="root === 'teamDialog' ? disabledValue.indexOf(item.value) > -1 : item.disabled"
        :key="`${item.value + '' + index + Date.now()}`"
        :value="item.value"
        :label="item.label"
      >
    <div class="select-group-container">
       
          <common-ellipsis-tooltip
            popper-class=''
            effect="dark"
            :content="item.label"
            placement="top"
          >                
          </common-ellipsis-tooltip>
          <div>
              {{ item.message }}
            </div>
        </div>
      </label-select-option>
    </slot>
  </label-select>
</span>
  
</template>

<script>
import {
  LabelSelect,
  LabelSelectOption,
} from "@/components/label-input-v2/select";

export default {
  props: {
    inputWidth: {
      required: false,
      default: "",
    },
    seletData: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    disabledValue: {
        type: Array,
        default: () => [],
    },
    root: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      require: false,
      default: "",
    },
  },

  data() {
    return {};
  },
  components: {
    LabelSelect: LabelSelect,
    LabelSelectOption: LabelSelectOption,
  },
};
</script>

<style lang="scss" scoped>
span {
  position: relative;
  display: inline-block;
}
/deep/ .el-input__suffix-inner .el-icon-arrow-up::before {
      display: block;
      height: 14px !important;
      width: 14px !important;
      content: url('../images/icon-16-drop-down (1).svg');
      transform: translateY(2px) translateX(4px) !important;

}
.select-group-container {
  div {
    font-weight: 500;
    font-size: 12px;
    font-weight: 500;
line-height: 12px;
    color: #000000;
    &:last-child {
      color: #b2b6c0;
    }
  }
}
/deep/ .el-select .el-input .el-select__caret {
  transform: rotateZ(0deg);
}
/deep/ .el-select .el-input .el-select__caret.is-reverse{
  transform: rotateZ(180deg) !important;
}
//  /deep/  .el-input__icon::before {
        
//     } 
//     /deep/ .is-disabled .el-input__icon::before {
//         display: block;
//         height: 16px;
//         width: 16px;
//         content: url('../../icons/icon-16-drop-down (1).svg') !important;
//         transform: translateY(4px) translateX(4px);
//     }
</style>
